/* eslint-disable no-unused-vars */
export enum Exchange {
  AERODROME = 0,
  AERODROME_SLIPSTREAM = 1,
  ETHERFI = 2,
  UNISWAP_V2 = 3,
  UNISWAP_V3 = 4,
}
